// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"cc105b84","182":"b1f15c4a","321":"6858adf5","338":"60a3bfac","551":"03bced4b","628":"5bd172ad","640":"a450bd3d","645":"d5b6f92f","842":"ca086022","883":"71cfa834","910":"f7f9fe64","942":"71e54631"}[chunkId] + ".chunk.js";
};